import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Modal } from 'antd';
import '../../../index.scss';
import { customBaseUrl, httpPost } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';

const CreateCardProduct = ({ showModal, hideModal, className, getProducts }) => {
  const [data, setData] = useState({
    cardFee: '',
    cardProduct: '',
    maintenanceFee: '',
    active: true
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.cardProduct || !data.cardFee) {
      Swal.fire('Warning', 'Card Product name and Card Fee are required', 'warning');
      return;
    }

    showLoader();
    const activeStatus = data.active ?? true;
    let res = await httpPost(
      `${customBaseUrl.cardUrl}/cms/admin/create-card/product?cardFee=${data.cardFee}&cardProduct=${data.cardProduct}&maintenanceFee=${data.maintenanceFee || 0}&active=${activeStatus}`
    );

    if (res?.message === 'Succesful' || res?.message === 'Successful' || res?.status === true || res?.respCode === 0) {
      hideLoader();
      Swal.fire('Done', res.message || 'Card product created successfully', 'success');
      hideModal(false);
      getProducts();
    } else {
      hideLoader();
      Swal.fire('Error', res?.message || 'Failed to create card product', 'error');
    }
  };

  return (
    <Modal
      className={className}
      title={<span style={{ fontSize: '18px', fontWeight: 700, color: '#1C1C1C' }}>Create Card Product</span>}
      centered
      visible={showModal}
      open={showModal}
      onOk={() => hideModal(false)}
      onCancel={() => hideModal(false)}
      width={550}
      footer={null}
      bodyStyle={{ padding: '24px' }}
    >
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054' }} htmlFor='cardFeeCreateInput'>
              Card Fee (NGN)
            </label>
            <input
              type='number'
              style={{
                width: '100%',
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #D0D5DD',
                fontSize: '14px',
                outline: 'none',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                transition: 'border-color 0.2s'
              }}
              id='cardFeeCreateInput'
              required
              placeholder='1000'
              value={data.cardFee}
              onChange={(e) => setData({ ...data, cardFee: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054' }} htmlFor='cardProductCreateInput'>
              Card Product
            </label>
            <input
              type='text'
              required
              style={{
                width: '100%',
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #D0D5DD',
                fontSize: '14px',
                outline: 'none',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                transition: 'border-color 0.2s'
              }}
              id='cardProductCreateInput'
              placeholder='Visa / Verve / Mastercard'
              value={data.cardProduct}
              onChange={(e) => setData({ ...data, cardProduct: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054' }} htmlFor='maintenanceFeeCreateInput'>
              Maintenance Fee (NGN)
            </label>
            <input
              type='number'
              style={{
                width: '100%',
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #D0D5DD',
                fontSize: '14px',
                outline: 'none',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                transition: 'border-color 0.2s'
              }}
              id='maintenanceFeeCreateInput'
              placeholder='50'
              value={data.maintenanceFee}
              onChange={(e) => setData({ ...data, maintenanceFee: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '4px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054', marginBottom: 0 }} htmlFor='activeSwitchProductCreate'>
              Active Status
            </label>
            <div className='form-check form-switch mb-0'>
              <input
                className='form-check-input'
                type='checkbox'
                id='activeSwitchProductCreate'
                style={{ width: '40px', height: '20px', cursor: 'pointer', margin: 0 }}
                checked={data.active}
                onChange={(e) => setData({ ...data, active: e.target.checked })}
              />
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '12px' }}>
            <button
              type='submit'
              style={{
                background: '#FF4B01',
                color: '#fff',
                border: 'none',
                padding: '12px 32px',
                fontSize: '15px',
                fontWeight: 600,
                borderRadius: '8px',
                cursor: 'pointer',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                width: '100%',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.background = '#E04200'}
              onMouseLeave={(e) => e.target.style.background = '#FF4B01'}
            >
              Create Product
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default CreateCardProduct;
